import type { MinimumStationsGroup } from '@mi-front/core';
import { UserRole } from '@mi-front/core';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { apiClient } from '../../../api';
import { useHasRole } from '../../auth/authorization/hooks/useHasRole';

/**
 * React Query hook for station groups. Cache is primed from app-init in AuthBootstrap.
 * Superadmin has groups disabled and uses empty array.
 */
export function useStationsGroupsQuery() {
  const isSuperadmin = useHasRole(UserRole.SUPERADMIN);

  return useQuery({
    queryKey: ['stations-groups'],
    queryFn: () => apiClient.stations.fetchAllStationGroups(),
    enabled: !isSuperadmin,
    initialData: isSuperadmin ? [] : undefined,
    staleTime: Infinity,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
}

/**
 * Returns station groups from the query. Empty array when loading or superadmin.
 */
export function useStationsGroups(): MinimumStationsGroup[] {
  const query = useStationsGroupsQuery();

  return useMemo(() => query.data ?? [], [query.data]);
}
